export function dedupeDepotStops<T extends { type?: string | null; lat?: number | null; lng?: number | null }>(
  stops: T[] | undefined,
): T[] {
  if (!stops) return [];
  const seenDepotLocations = new Set<string>();
  const result: T[] = [];
  for (const stop of stops) {
    if (stop.type === 'depot') {
      const locationKey = `${stop.lat},${stop.lng}`;
      if (seenDepotLocations.has(locationKey)) continue;
      seenDepotLocations.add(locationKey);
    }
    result.push(stop);
  }
  return result;
}
